import { createFileRoute } from '@tanstack/react-router'
import { TrendingUpDownIcon } from 'lucide-react'

import { UnderConstructionPage } from '@/components/under-construction'

export const Route = createFileRoute('/_dashboard/site/$id/drift/equipment/')({
  component: () => (
    <UnderConstructionPage
      titleKey="dashboard.sidebar.driftEquipmentsTitle"
      icon={<TrendingUpDownIcon className="size-6" />}
      descriptionKey="underConstruction.beforeEndOfYear"
    />
  ),
})
